import Keycloak from "keycloak-js";
import { CLIENT_ID, KEYCLOAK_URL, REALM } from "../constants/environment";
import { AuthConfig } from "../domain/authConfig";

const keycloak = ({ client = CLIENT_ID }: AuthConfig) => {
  return new Keycloak({
    url: KEYCLOAK_URL,
    realm: REALM,
    clientId: client,
  });
};

export default keycloak;
